<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="md" :visible="modal.show" :data="model" scrollable
                   :title="model.uuid ? $t(`Update Item`) : $t(`Add New Item`)" @show="onShow"
                   @hidden="onHidden" @ok.prevent="onSubmit" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" modal-class="mobile-full-screen">
      <div class="row">
        <div class="col-md-12">
          <inventory-select-input-widget with-image :model="model" attribute="inventory_uuid"
                                         expand="latest_reservation.auction,department,category,item_location"
                                         @select="onInventorySelect"/>
        </div>
        <div class="col-md-12">
          <item-location-select-input-widget :model="model" attribute="new_item_location_uuid"
                                             @select="onNewItemLocationSelect"/>
        </div>
        <div class="col-md-12">
          <input-widget :model="model" attribute="fao"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import TransferNoteItemModel from "@/modules/transfer-notes/TransferNoteItem.model";
  import InventorySelectInputWidget from "@/core/widgets/InventorySelectInputWidget";
  import ItemLocationSelectInputWidget from "@/core/widgets/ItemLocationSelectInputWidget";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import {ON_TRANSFER_NOTE_ITEM_SUBMIT} from "@/plugins/event-bus/event-bus-names";

  const {mapState, mapActions} = createNamespacedHelpers('transferNotes');

  export default {
    name: "TransferNoteItemModal",
    components: {
      InputWidget,
      ItemLocationSelectInputWidget,
      InventorySelectInputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new TransferNoteItemModel(),
        errorMessage: null,
      }
    },
    computed: {
      ...mapState({
        modal: state => state.itemModal,
        editObject: state => state.itemModal.object,
      }),
    },
    watch: {
      editObject() {
        if (this.editObject) {
          this.model = new TransferNoteItemModel(this.editObject);
        }
      },
    },
    methods: {
      ...mapActions(['hideItemModal']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new TransferNoteItemModel();
        this.hideItemModal();
      },
      async onSubmit() {
        await this.$refs.observer.reset();
        let validateSuccess = await this.$refs.observer.validate();
        if (!validateSuccess) {
          return;
        }
        this.showConfirmation = false
        this.$evBus.$emit(ON_TRANSFER_NOTE_ITEM_SUBMIT, {
          data: this.model.toJSON()
        });
        this.hideItemModal()
      },
      onInventorySelect(inv) {
        this.model.inventory = inv
      },
      onNewItemLocationSelect(itemLocation) {
        this.model.new_item_location = itemLocation
      }
    }
  }
</script>

<style scoped>

</style>
